import auth from "./auth";
import teacher from "./teacher";

const section = {
  auth,
  teacher
}

export default section